module.exports = __webpack_public_path__ + "img/属性.50cde38f.svg";